import { render, staticRenderFns } from "./AccessControlEditor.vue?vue&type=template&id=61be8f2e&"
import script from "./AccessControlEditor.vue?vue&type=script&lang=js&"
export * from "./AccessControlEditor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports